const { env } = require('./env');


module.exports = {
	api: {
		REACT_APP_SPED_AUTH_API_URL:
			env.REACT_APP_SPED_AUTH_API_URL || 'http://localhost:8000',
		REACT_APP_SPED_CORE_API_URL:
			env.REACT_APP_SPED_CORE_API_URL || 'http://localhost:8019',
		REACT_APP_SPED_ESTABLISHMENT_API_URL:
			env.REACT_APP_SPED_ESTABLISHMENT_API_URL || 'http://localhost:8021/',
		REACT_APP_SPED_NORMATIVE_API_URL:
			env.REACT_APP_SPED_NORMATIVE_API_URL || 'http://localhost:8022/',
		REACT_APP_SPED_RESIDUE_API_URL:
			env.REACT_APP_SPED_RESIDUE_API_URL || 'http://localhost:8023/',
		REACT_APP_SPED_TRANSFER_API_URL:
			env.REACT_APP_SPED_TRANSFER_API_URL || 'http://localhost:8024/',
		REACT_APP_SPED_FILE_MANAGER_API_URL:
			env.REACT_APP_SPED_FILE_MANAGER_API_URL || 'http://localhost:8025/',
		REACT_APP_SPED_ACTIVITY_API_URL:
			env.REACT_APP_SPED_ACTIVITY_API_URL || 'http://localhost:8026/',
		REACT_APP_SPED_SCREEN_API_URL:
			env.REACT_APP_SPED_SCREEN_API_URL || 'http://localhost:8027/',
		REACT_APP_SPED_MESSAGE_API_URL:
			env.REACT_APP_SPED_MESSAGE_API_URL || 'http://localhost:8028/',
		REACT_APP_SPED_WAREHOUSE_API_URL:
			env.REACT_APP_SPED_WAREHOUSE_API_URL || 'http://localhost:8029/',
		REACT_APP_SPED_WATER_RIGHTS_API_URL:
			env.REACT_APP_SPED_WATER_RIGHTS_API_URL || 'http://localhost:8030',
		REACT_APP_SPED_INSPECTION_API_URL:
			env.REACT_APP_SPED_INSPECTION_API_URL || 'http://localhost:8002',

		REACT_APP_SPED_MESSAGE_API_WS_URL:
			env.REACT_APP_SPED_MESSAGE_API_WS_URL || 'ws://localhost:8028',

		REACT_APP_SPED_DATA_FINANCE_API_URL:
			env.REACT_APP_SPED_DATA_FINANCE_API_URL ||
			'https://cooke-qa-finance.sped.cl',
		REACT_APP_SPED_DATA_PROVIDERS_API_URL:
			env.REACT_APP_SPED_DATA_PROVIDERS_API_URL || 'http://localhost:8031',
		REACT_APP_SPED_DATA_API_URL:
			env.REACT_APP_SPED_DATA_API_URL || 'https://data.sped.cl',
		REACT_APP_SPED_ORIGINAL_API_URL:
			env.REACT_APP_SPED_ORIGINAL_API_URL || 'https://cermaq.sped.cl',
		REACT_APP_SPED_WEATHER_API_URL:
			env.REACT_APP_SPED_WEATHER_API_URL || 'https://weather.sped.cl',
		REACT_APP_GBUSINESS_API_URL:
			env.REACT_APP_GBUSINESS_API_URL || 'http://localhost:8032',
		REACT_APP_SPED_MONITORING_FAN_API_URL:
			env.REACT_APP_SPED_MONITORING_FAN_API_URL || 'https://data.sped.cl',
	},
	constants: {
		REACT_APP_DEFAULTAUTH: env.REACT_APP_DEFAULTAUTH || 'jwt',
		REACT_APP_FILE_MANAGER_STORAGE_SIZE:
			env.REACT_APP_FILE_MANAGER_STORAGE_SIZE || '1GB',
		REACT_APP_MAPBOX: env.REACT_APP_MAPBOX || 'pk.eyJ1Ijoib3BlbmxpbmsiLCJhIjoiY2xmdHY2MDI2MDA0MTNrbXoydmdsanZ5OCJ9.x65UPF-NxITbBD-niKxEKw',
	},
	residue_config: {
		REACT_APP_DTE_ENABLED: env.REACT_APP_DTE_ENABLED || true, // ✅ ACTIVADO para DTE automático
		REACT_APP_TRANSFER_CATEGORY_MARITIME:
			env.REACT_APP_TRANSFER_CATEGORY_MARITIME || '660c0ded84e981c2bdf65d0d',
		REACT_APP_TRANSFER_CATEGORY_GROUND:
			env.REACT_APP_TRANSFER_CATEGORY_GROUND || '660c0de484e981c2bdf65d0c',
		// Tipos de Residuo (usados como tipos de operación en el generador de guías)
		REACT_APP_RESIDUE_TYPE_PELIGROSOS:
			env.REACT_APP_RESIDUE_TYPE_PELIGROSOS || '662efcff8ddfdcb64699a9ac',
		REACT_APP_RESIDUE_TYPE_NO_PELIGROSOS:
			env.REACT_APP_RESIDUE_TYPE_NO_PELIGROSOS || '662efd078ddfdcb64699a9ad',
		REACT_APP_RESIDUE_TYPE_BEACH_CLEANING:
			env.REACT_APP_RESIDUE_TYPE_BEACH_CLEANING || '69860c4ade5be2903d6a64d5',
		// Categoría de Residuo para Limpieza de Playa
		REACT_APP_RESIDUE_CATEGORY_BEACH_CLEANING:
			env.REACT_APP_RESIDUE_CATEGORY_BEACH_CLEANING || '69860c51de5be2903d6a64d6',
		// Ingreso RESPEL: filtro de categorías de residuo (default = peligrosos)
		REACT_APP_RESPEL_INTAKE_RESIDUE_TYPE_ID:
			env.REACT_APP_RESPEL_INTAKE_RESIDUE_TYPE_ID ||
			env.REACT_APP_RESIDUE_TYPE_PELIGROSOS ||
			'662efcff8ddfdcb64699a9ac',
	},
	warehouse_config: {
		// ID del tipo de uso de bodega EPP (war_warehouse_usage_type)
		REACT_APP_WAREHOUSE_USAGE_TYPE_EPP_ID:
			env.REACT_APP_WAREHOUSE_USAGE_TYPE_EPP_ID ||
			'687faca8d289f04e7ff7bc98',
		// ID del tipo de uso RESPEL — tras seed en QA/prod (DECISIONS D-008)
		REACT_APP_WAREHOUSE_USAGE_TYPE_RESPEL_ID:
			env.REACT_APP_WAREHOUSE_USAGE_TYPE_RESPEL_ID || '',
		// ID del tipo de uso Residuos No Peligrosos (D-027)
		REACT_APP_WAREHOUSE_USAGE_TYPE_RESIDUOS_NP_ID:
			env.REACT_APP_WAREHOUSE_USAGE_TYPE_RESIDUOS_NP_ID || '',
	},
	oauth_microsoft: {
		REACT_APP_MICROSOFT_TENANT_ID:
			env.REACT_APP_MICROSOFT_TENANT_ID ||
			'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
		REACT_APP_MICROSOFT_CLIENT_ID:
			env.REACT_APP_MICROSOFT_CLIENT_ID ||
			'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
		REACT_APP_MICROSOFT_APP_CLIENT_ID:
			env.REACT_APP_MICROSOFT_APP_CLIENT_ID ||
			'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
		REACT_APP_MICROSOFT_CODE_CHALLENGE:
			env.REACT_APP_MICROSOFT_CODE_CHALLENGE || 'xxxxxxxx',
		REACT_APP_REDIRECT_URL:
			env.REACT_APP_REDIRECT_URL || 'http://localhost:3000/oauth2-redirect',
	},
	user_finance: {
		USER: env.DATA_FINANCE_USER || 'admin',
		PASS: env.DATA_FINANCE_PASS || 'TJBQC0aKgucSIJRg66xdUtD7iIB29eqr',
	},
	user_providers: {
		USER: env.DATA_PROVIDERS_USER || 'admin',
		PASS:
			env.DATA_PROVIDERS_PASS ||
			'45e8087c932ad0154fa08a83a06deee5c0c07f74883976ff88c0e97853e84291',
	},
	gbusiness: {
		// DTE API credentials
		USER: env.REACT_APP_SPED_GBUSINESS_USERNAME || 'admin',
		PASS: env.REACT_APP_SPED_GBUSINESS_PASSWORD || 'admin',
	},
};
